import { graphql, useStaticQuery } from "gatsby";

export const useShopifyCategories = () => {
  const { Bushbuck } = useStaticQuery(graphql`
    query {
      Bushbuck: allShopifyCollection(
        filter: { products: { elemMatch: { vendor: { eq: "Bushbuck" } } } }
      ) {
        nodes {
          shopifyId
          title
          products {
            title
            vendor
          }
        }
      }
    }
  `);

  return {
    Bushbuck: Bushbuck.nodes,
  };
};
